module.exports = require("codemirror/lib/codemirror.css");